import { Box, Text } from '@chakra-ui/react'
import type { CalloutBlock } from '../../../types/reporting'

/**
 * Where methodology caveats live. Deliberately NOT marked .no-print — a caveat that vanishes
 * from the PDF is worse than no caveat, because the number travels without it.
 */
export function CalloutBlockView({ block }: { block: CalloutBlock }) {
  const warning = block.tone === 'Warning'
  return (
    <Box
      className="report-block"
      borderLeftWidth="4px"
      borderLeftColor={warning ? 'orange.400' : 'info.fg'}
      bg={warning ? 'orange.50' : 'info.subtle'}
      px={4} py={3} borderRadius="md"
    >
      {!!block.title && <Text fontWeight="semibold" mb={1}>{block.title}</Text>}
      <Text fontSize="sm">{block.body}</Text>
    </Box>
  )
}
